var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWrench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Error---Generic",
    transform: "translate(-656.000000, -275.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(464.000000, 275.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(256.000000, 64.000000) rotate(180.000000) translate(-256.000000, -64.000000) translate(192.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F0B423",
    cx: 64,
    cy: 64,
    r: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(34.000000, 34.000000)",
    fill: "#231F1F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54,8 C54,6.897 53.103,6 52,6 C50.897,6 50,6.897 50,8 C50,9.103 50.897,10 52,10 C53.103,10 54,9.103 54,8",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.535,3.121 L56.879,1.464 C55.934,0.52 54.679,0 53.343,0 C52.007,0 50.751,0.52 49.816,1.456 L21.607,29.011 C19.817,28.34 17.934,28 16,28 C7.178,28 0,35.178 0,44 C0,45.834 0.325,47.663 0.966,49.434 C1.082,49.756 1.355,49.996 1.689,50.07 C2.025,50.146 2.372,50.042999 2.613,49.801 L13,39.414 L20.586,47 L10.199,57.387001 C9.957,57.627998 9.856,57.977001 9.93,58.311001 C10.004,58.645 10.244,58.917999 10.566,59.0340004 C12.337,59.6749992 14.165,60 16,60 C24.822,60 32,52.821999 32,44 C32,41.843 31.578,39.75 30.738,37.762 C30.698,37.672 29.734,35.534 27.531,34.153 C27.064,33.86 26.447,34.002 26.153,34.469 C25.859,34.936 26.001,35.554 26.469,35.847 C28.136,36.893 28.902,38.556 28.902,38.556 C29.631,40.28 30,42.112 30,44 C30,51.720001 23.72,58 16,58 C14.926,58 13.854,57.872002 12.796,57.618999 L22.707,47.707 C23.098,47.316 23.098,46.684 22.707,46.293 L13.707,37.293 C13.316,36.902 12.684,36.902 12.293,37.293 L2.381,47.204 C2.128,46.146 2,45.074 2,44 C2,36.28 8.28,30 16,30 C17.891,30 19.725,30.371 21.451,31.101 C21.82,31.257 22.251,31.178 22.54,30.895 L51.222,2.878 C52.354,1.746 54.331,1.746 55.465,2.878 L57.121,4.535 C57.688,5.102 58,5.855 58,6.657 C58,7.458 57.688,8.211 57.113,8.787 L31.756,34.757 C31.37,35.153 31.378,35.786 31.773,36.171 C32.168,36.558 32.802,36.551 33.187,36.155 L58.535,10.192 C59.48,9.248 60,7.993 60,6.657 C60,5.321 59.48,4.065 58.535,3.121",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,40 C21.256,40 21.512,39.902 21.707,39.707 L23.707,37.707 C24.098,37.316 24.098,36.684 23.707,36.293 C23.316,35.902 22.684,35.902 22.293,36.293 L20.293,38.293 C19.902,38.684 19.902,39.316 20.293,39.707 C20.488,39.902 20.744,40 21,40",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,43 C24.256,43 24.512,42.902 24.707,42.707 L26.707,40.707 C27.098,40.316 27.098,39.684 26.707,39.293 C26.316,38.902 25.684,38.902 25.293,39.293 L23.293,41.293 C22.902,41.684 22.902,42.316 23.293,42.707 C23.488,42.902 23.744,43 24,43",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.707,33.293 C20.316,32.902 19.684,32.902 19.293,33.293 L17.293,35.293 C16.902,35.684 16.902,36.316 17.293,36.707 C17.488,36.902 17.744,37 18,37 C18.256,37 18.512,36.902 18.707,36.707 L20.707,34.707 C21.098,34.316 21.098,33.684 20.707,33.293",
    id: "Fill-6"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWrench);
export default __webpack_public_path__ + "static/media/Icon_Wrench.81fe197389f5aa4f899101ebb7194a49.svg";
export { ForwardRef as ReactComponent };